import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import Container from "../../common/Container";
import Banner from "../components/Banner";
import Clients from "../components/Clients";
import SeoTexts from "../components/SeoTexts";
import BreadcrumbsContainer from "../components/BreadcrumbsContainer";
import RootMenu from "../components/RootMenu";
import RootProducts from "../components/RootProducts";
import {onPlatformSelector} from "../ducks/onPlatform";
import classnames from "classnames";
import VTBBanner from "../components/VTBBanner";

import styles from "./products.module.scss";

function Root({onPlatform}) {
  return (
    <Grid
      container
      className={classnames(styles.root, {
        [styles.rootVTB]: onPlatform
      })}
    >
      {onPlatform !== `vtb` && (
        <Grid item xs={12} className={styles.breadcrumbs}>
          <Container>
            <BreadcrumbsContainer />
          </Container>
        </Grid>
      )}
      <Grid item xs={12} className={styles.banner}>
        {onPlatform !== `vtb` ? <Banner /> : <VTBBanner />}
      </Grid>
      <Grid item xs={12} className={styles.switch}>
        <RootMenu />
      </Grid>
      <Grid item xs={12} className={styles.content}>
        <Container>
          <RootProducts />
        </Container>
      </Grid>
      {onPlatform !== `vtb` && (
        <Grid item xs={12} className={styles.b2b}>
          <Clients />
        </Grid>
      )}
      <Grid item xs={12} className={styles.beforeFooterText}>
        <Container>
          <SeoTexts />
        </Container>
      </Grid>
    </Grid>
  );
}

Root.propTypes = {
  onPlatform: PropTypes.string
};

const mapStateToProps = (state) => ({
  onPlatform: onPlatformSelector(state)
});

export default connect(mapStateToProps)(Root);
